import { CookieExpireAfter } from "@/helpers/common/CookieExpire";
import axiosRequest from "@/utils/axios-config";
import { decodeJwt } from "@/utils/global";
import { setCookie } from "cookies-next";

const handShake = async (locale, req, res) => {
  const config = {
    method: "post",
    url: "/handshake",
    data: { store: locale },
  };
  try {
    const reqAxios = await axiosRequest(config);

    const expire =
      (decodeJwt(reqAxios?.data?.token)?.exp || 0) * 1000
        ? new Date((decodeJwt(reqAxios?.data?.token)?.exp || 0) * 1000)
        : CookieExpireAfter(10);

    if (req && res) {
      setCookie("handshake", reqAxios?.data?.token, {
        req,
        res,
        expires: expire,
      });
    } else {
      setCookie("handshake", reqAxios?.data?.token, {
        expires: expire,
      });
    }
    console.log("handshake", reqAxios.data);
    return reqAxios;
  } catch (error) {
    return error;
  }
};

const fetchHandshake = async ({ req, res, locale }) => {
  // get handshake from cookies or generate new handshake
  const { handshake: token } = req.cookies;

  const handshake =
    token &&
    locale == decodeJwt(token)?.storeName &&
    decodeJwt(token)?.exp * 1000 > Date.now()
      ? token
      : (await handShake(locale, req, res))?.data?.token;

  return handshake;
};

const gethandShake = async (locale) => {
  const config = {
    method: "post",
    url: "/handshake",
    data: { store: locale },
  };
  try {
    const reqAxios = await axiosRequest(config);
    return reqAxios;
  } catch (error) {
    return error;
  }
};

export { handShake, fetchHandshake, gethandShake };
